import { Component, OnDestroy, OnInit } from "@angular/core";
import { CAROUSEL } from "../shared/carousel.consts";
import { UpperCasePipe } from "@angular/common";

@Component({
    selector: 'app-authentication-carousel',
    templateUrl: './authentication-carousel.component.html',
    imports: [UpperCasePipe],
    styles: [`
    :host {
      width: 100%;
      display: block;
    }
  `]
})
export class AuthenticationCarouselComponent implements OnInit, OnDestroy {
  private carouselIntervalId: any;
  activeCarousel: number = 0;
  carouselDetails = CAROUSEL;

  ngOnInit(): void {
    this.startAutoPlay();
  }
  
  ngOnDestroy(): void {
    this.clearAutoPlay();
  }

  changeActiveIndex(index: number) {
    this.activeCarousel = index;
    this.startAutoPlay();
  }

  startAutoPlay() {
    this.clearAutoPlay();

    this.carouselIntervalId = setInterval(() => {
      if (!this.carouselDetails?.length) return;

      this.activeCarousel = (this.activeCarousel + 1) % this.carouselDetails.length;
    }, 10000);
  }

  clearAutoPlay() {
    if (this.carouselIntervalId) {
      clearInterval(this.carouselIntervalId);
      this.carouselIntervalId = null;
    }
  }
}